import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { ITakeTeilnehmerState } from './state';

export const GETTAKETEILNEHMERDATA = 'getTakeTeilnehmerData';
export const GET_TEILNEHMER_DATA = 'getTeilnehmerList';
export const GET_TEILNEHMER_LOADING = 'getTeilnehmerLoading';
export const GET_TEILNEHMER_TOTAL_NUMBER_OF_RECORDS = 'getTeilnehmerTotalNumberOfRecords';

export const getters: GetterTree<ITakeTeilnehmerState, IRootState> = {
    [GETTAKETEILNEHMERDATA]: (state) => state.teilnehmer,
    [GET_TEILNEHMER_DATA]: (state) => state.teilnehmerList,
    [GET_TEILNEHMER_LOADING]: (state) => state.teilnehmerLoading,
    [GET_TEILNEHMER_TOTAL_NUMBER_OF_RECORDS]: (state) => state.teilnehmerTotalNumberOfRecords
};
